<template>
  <div class="dashboard">
    <el-row :gutter="20">
      <el-col :span="6">
        <div class="stat-card">
          <div class="stat-icon" style="background: #e6f7ff;">
            <i class="el-icon-s-order" style="color: #1677FF;"></i>
          </div>
          <div class="stat-body">
            <div class="stat-label">总订单数</div>
            <div class="stat-value">{{ stats.totalOrders }}</div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="stat-card">
          <div class="stat-icon" style="background: #f6ffed;">
            <i class="el-icon-goods" style="color: #52c41a;"></i>
          </div>
          <div class="stat-body">
            <div class="stat-label">商品总数</div>
            <div class="stat-value">{{ stats.totalGoods }}</div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="stat-card">
          <div class="stat-icon" style="background: #fff7e6;">
            <i class="el-icon-shop" style="color: #fa8c16;"></i>
          </div>
          <div class="stat-body">
            <div class="stat-label">{{ subEntityLabel }}</div>
            <div class="stat-value">{{ totalSubEntities }}</div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="stat-card">
          <div class="stat-icon" style="background: #f9f0ff;">
            <i class="el-icon-s-claim" style="color: #722ed1;"></i>
          </div>
          <div class="stat-body">
            <div class="stat-label">今日订单</div>
            <div class="stat-value">{{ stats.todayOrders }}</div>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20" style="margin-top: 20px;">
      <el-col :span="12">
        <el-card shadow="never">
          <div slot="header" class="card-header">
            <span>每日订单数趋势</span>
            <div class="legend-control">
              <el-checkbox-group v-model="orderChartVisibleShops" @change="drawOrderChart">
                <el-checkbox v-for="shop in chartShops" :key="shop.id" :label="shop.id" :checked="true">
                  <span :style="{color: shop.color}">{{ shop.name }}</span>
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <div class="chart-container">
            <canvas ref="orderChart" width="600" height="280"></canvas>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="never">
          <div slot="header" class="card-header">
            <span>每日订单租金金额趋势</span>
            <div class="legend-control">
              <el-checkbox-group v-model="amountChartVisibleShops" @change="drawAmountChart">
                <el-checkbox v-for="shop in chartShops" :key="shop.id" :label="shop.id" :checked="true">
                  <span :style="{color: shop.color}">{{ shop.name }}</span>
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <div class="chart-container">
            <canvas ref="amountChart" width="600" height="280"></canvas>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" style="margin-top: 20px;">
      <el-col :span="12">
        <el-card shadow="never">
          <div slot="header" class="card-header">
            <span>最近订单</span>
            <el-button type="text" size="small" @click="$router.push('/order/list')">查看全部</el-button>
          </div>
          <el-table :data="recentOrders" style="width: 100%" size="small">
            <el-table-column prop="orderNo" label="订单编号" min-width="160" />
            <el-table-column prop="goodsName" label="商品名称" min-width="120" />
            <el-table-column prop="orderPrice" label="订单金额" width="100">
              <template slot-scope="scope">
                ¥{{ scope.row.orderPrice }}
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="90">
              <template slot-scope="scope">
                <el-tag :type="getOrderStatusType(scope.row.status)" size="mini">
                  {{ getOrderStatusText(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="never">
          <div slot="header" class="card-header">
            <span>最新商品</span>
            <el-button type="text" size="small" @click="$router.push('/goods/list')">查看全部</el-button>
          </div>
          <el-table :data="recentGoods" style="width: 100%" size="small">
            <el-table-column prop="name" label="商品名称" min-width="140" />
            <el-table-column prop="category" label="分类" width="100" />
            <el-table-column prop="dailyRent" label="日租金" width="100">
              <template slot-scope="scope">
                ¥{{ scope.row.dailyRent }}/天
              </template>
            </el-table-column>
            <el-table-column prop="stock" label="库存" width="70" />
          </el-table>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getGoodsList } from '@/api/goods'
import { getOrderList, getDashboardStats, getDailyStats } from '@/api/order'
import { getShopList } from '@/api/shop'
import { getServiceProviderList } from '@/api/serviceProvider'
import { getMiniAppList } from '@/api/miniApp'

const CHART_COLORS = [
  '#1677FF', '#52c41a', '#fa8c16', '#722ed1', '#eb2f96',
  '#13c2c2', '#faad14', '#f5222d', '#2f54eb', '#73d13d'
]

export default {
  name: 'Dashboard',
  data() {
    return {
      roleType: '',
      stats: {
        totalOrders: 0,
        totalGoods: 0,
        totalShops: 0,
        totalMiniApps: 0,
        totalServiceProviders: 0,
        todayOrders: 0
      },
      recentOrders: [],
      recentGoods: [],
      shopOptions: [],
      chartShops: [],
      orderChartVisibleShops: [],
      amountChartVisibleShops: [],
      dailyStats: []
    }
  },
  computed: {
    subEntityLabel() {
      if (this.roleType === 'SYSTEM_ADMIN') return '服务商总数'
      if (this.roleType === 'SERVICE_PROVIDER') return '小程序总数'
      return '店铺总数'
    },
    totalSubEntities() {
      if (this.roleType === 'SYSTEM_ADMIN') return this.stats.totalServiceProviders
      if (this.roleType === 'SERVICE_PROVIDER') return this.stats.totalMiniApps
      return this.stats.totalShops
    }
  },
  created() {
    this.loadRoleType()
    this.loadStats()
  },
  methods: {
    loadRoleType() {
      const adminInfo = localStorage.getItem('admin_info')
      if (adminInfo) {
        try {
          const info = JSON.parse(adminInfo)
          this.roleType = info.admin?.roleType || 'SYSTEM_ADMIN'
        } catch (e) {
          console.error('解析用户信息失败', e)
        }
      }
    },
    async loadStats() {
      try {
        // 根据角色查询不同的统计数据
        if (this.roleType === 'SYSTEM_ADMIN') {
          // 系统管理员：查询服务商数量
          const [orderRes, goodsRes, spRes] = await Promise.all([
            getOrderList({ page: 1, size: 5 }),
            getGoodsList({ page: 1, size: 5, status: -1 }),
            getServiceProviderList()
          ])
          if (orderRes.data && orderRes.data.records) {
            this.recentOrders = orderRes.data.records
            this.stats.totalOrders = orderRes.data.total || 0
          }
          if (goodsRes.data && goodsRes.data.records) {
            this.recentGoods = goodsRes.data.records
            this.stats.totalGoods = goodsRes.data.total || 0
          }
          if (spRes.data) {
            this.stats.totalServiceProviders = spRes.data.length || 0
          }
        } else if (this.roleType === 'SERVICE_PROVIDER') {
          // 服务商管理员：查询小程序数量
          const [orderRes, goodsRes, maRes] = await Promise.all([
            getOrderList({ page: 1, size: 5 }),
            getGoodsList({ page: 1, size: 5, status: -1 }),
            getMiniAppList()
          ])
          if (orderRes.data && orderRes.data.records) {
            this.recentOrders = orderRes.data.records
            this.stats.totalOrders = orderRes.data.total || 0
          }
          if (goodsRes.data && goodsRes.data.records) {
            this.recentGoods = goodsRes.data.records
            this.stats.totalGoods = goodsRes.data.total || 0
          }
          if (maRes.data) {
            this.stats.totalMiniApps = maRes.data.length || 0
          }
        } else {
          // 小程序管理员：查询店铺数量
          const [orderRes, goodsRes, shopRes] = await Promise.all([
            getOrderList({ page: 1, size: 5 }),
            getGoodsList({ page: 1, size: 5, status: -1 }),
            getShopList({ page: 1, size: 999 })
          ])
          if (orderRes.data && orderRes.data.records) {
            this.recentOrders = orderRes.data.records
            this.stats.totalOrders = orderRes.data.total || 0
          }
          if (goodsRes.data && goodsRes.data.records) {
            this.recentGoods = goodsRes.data.records
            this.stats.totalGoods = goodsRes.data.total || 0
          }
          if (shopRes.data && shopRes.data.records) {
            this.stats.totalShops = shopRes.data.total || 0
            this.shopOptions = shopRes.data.records || []
            this.chartShops = shopRes.data.records.map((shop, index) => ({
              ...shop,
              color: CHART_COLORS[index % CHART_COLORS.length]
            }))
            this.orderChartVisibleShops = shopRes.data.records.map(s => s.id.toString())
            this.amountChartVisibleShops = shopRes.data.records.map(s => s.id.toString())
          }
        }
      } catch (e) {
        console.error('加载仪表盘数据失败', e)
      }
      
      try {
        const statsRes = await getDashboardStats()
        if (statsRes.data) {
          this.stats.todayOrders = statsRes.data.todayOrders || 0
        }
      } catch (e) {
        console.error('加载今日订单数失败', e)
      }

      this.loadDailyStats()
    },
    async loadDailyStats() {
      try {
        const res = await getDailyStats()
        if (res.data) {
          this.dailyStats = res.data || []
          this.drawCharts()
        }
      } catch (e) {
        console.error('加载每日统计数据失败', e)
      }
    },
    drawCharts() {
      this.drawOrderChart()
      this.drawAmountChart()
    },
    drawOrderChart() {
      const canvas = this.$refs.orderChart
      if (!canvas) return
      const ctx = canvas.getContext('2d')
      ctx.clearRect(0, 0, canvas.width, canvas.height)

      const series = this.groupByShopAndDate(this.dailyStats, 'order_count', this.orderChartVisibleShops)
      this.drawMultiLineChart(ctx, canvas.width, canvas.height, series, '订单数')
    },
    drawAmountChart() {
      const canvas = this.$refs.amountChart
      if (!canvas) return
      const ctx = canvas.getContext('2d')
      ctx.clearRect(0, 0, canvas.width, canvas.height)

      const series = this.groupByShopAndDate(this.dailyStats, 'total_amount', this.amountChartVisibleShops)
      this.drawMultiLineChart(ctx, canvas.width, canvas.height, series, '金额(元)')
    },
    groupByShopAndDate(data, field, visibleShopIds) {
      const shopMap = {}
      const allDates = new Set()
      
      data.forEach(item => {
        const shopId = String(item.shop_id || item.shopId)
        if (!visibleShopIds.includes(shopId)) return
        
        const date = item.date || item.createdDate
        allDates.add(date)
        
        if (!shopMap[shopId]) {
          const shop = this.chartShops.find(s => String(s.id) === shopId)
          shopMap[shopId] = {
            shopId,
            shopName: shop ? shop.name : '未知店铺',
            color: shop ? shop.color : '#999',
            data: {}
          }
        }
        shopMap[shopId].data[date] = Number(item[field] || 0)
      })
      
      const dateArray = Array.from(allDates).sort().slice(-14)
      
      return Object.values(shopMap).map(shopData => ({
        ...shopData,
        data: dateArray.map(date => ({
          date,
          value: shopData.data[date] || 0
        }))
      }))
    },
    drawMultiLineChart(ctx, width, height, series, label) {
      if (!series || series.length === 0) {
        ctx.fillStyle = '#999'
        ctx.font = '14px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
        ctx.textAlign = 'center'
        ctx.fillText('暂无数据', width / 2, height / 2)
        return
      }

      const padding = { top: 40, right: 40, bottom: 50, left: 60 }
      const chartWidth = width - padding.left - padding.right
      const chartHeight = height - padding.top - padding.bottom

      let maxValue = 1
      let minValue = 0
      series.forEach(s => {
        const seriesMax = Math.max(...s.data.map(d => d.value), 1)
        const seriesMin = Math.min(...s.data.map(d => d.value), 0)
        if (seriesMax > maxValue) maxValue = seriesMax
        if (seriesMin < minValue) minValue = seriesMin
      })
      const range = maxValue - minValue
      if (range <= 0) range = 1

      ctx.fillStyle = '#fafafa'
      ctx.fillRect(padding.left, padding.top, chartWidth, chartHeight)

      ctx.strokeStyle = '#e0e0e0'
      ctx.lineWidth = 1
      ctx.setLineDash([4, 4])
      for (let i = 0; i <= 5; i++) {
        const y = padding.top + (chartHeight / 5) * i
        ctx.beginPath()
        ctx.moveTo(padding.left, y)
        ctx.lineTo(width - padding.right, y)
        ctx.stroke()
      }
      ctx.setLineDash([])

      ctx.strokeStyle = '#e8e8e8'
      ctx.lineWidth = 1
      const dates = series[0]?.data?.map(d => d.date) || []
      dates.forEach((_, index) => {
        const x = padding.left + (chartWidth / (dates.length - 1 || 1)) * index
        ctx.beginPath()
        ctx.moveTo(x, padding.top)
        ctx.lineTo(x, padding.top + chartHeight)
        ctx.stroke()
      })

      ctx.fillStyle = '#666'
      ctx.font = '12px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
      ctx.textAlign = 'right'
      for (let i = 0; i <= 5; i++) {
        const y = padding.top + (chartHeight / 5) * i
        const value = maxValue - (range / 5) * i
        ctx.fillText(Math.round(value).toLocaleString(), padding.left - 10, y + 4)
      }

      ctx.fillStyle = '#888'
      ctx.font = '11px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
      ctx.textAlign = 'center'
      const step = Math.max(1, Math.ceil(dates.length / 7))
      dates.forEach((date, index) => {
        if (index % step === 0) {
          const x = padding.left + (chartWidth / (dates.length - 1 || 1)) * index
          ctx.fillText(date.substring(5), x, height - 20)
        }
      })

      ctx.fillStyle = '#333'
      ctx.font = '14px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
      ctx.textAlign = 'left'
      ctx.fillText(label, padding.left, 20)

      series.forEach(shopSeries => {
        const gradient = ctx.createLinearGradient(0, padding.top, 0, padding.top + chartHeight)
        gradient.addColorStop(0, shopSeries.color + '40')
        gradient.addColorStop(1, shopSeries.color + '05')

        ctx.beginPath()
        ctx.moveTo(padding.left, padding.top + chartHeight)
        
        shopSeries.data.forEach((item, index) => {
          const x = padding.left + (chartWidth / (dates.length - 1 || 1)) * index
          const y = padding.top + chartHeight - ((item.value - minValue) / range) * chartHeight
          ctx.lineTo(x, y)
        })
        
        ctx.lineTo(padding.left + chartWidth, padding.top + chartHeight)
        ctx.closePath()
        ctx.fillStyle = gradient
        ctx.fill()

        ctx.beginPath()
        ctx.strokeStyle = shopSeries.color
        ctx.lineWidth = 2.5
        ctx.shadowColor = shopSeries.color
        ctx.shadowBlur = 6
        ctx.shadowOffsetY = 2

        shopSeries.data.forEach((item, index) => {
          const x = padding.left + (chartWidth / (dates.length - 1 || 1)) * index
          const y = padding.top + chartHeight - ((item.value - minValue) / range) * chartHeight
          
          if (index === 0) {
            ctx.moveTo(x, y)
          } else {
            const prevX = padding.left + (chartWidth / (dates.length - 1 || 1)) * (index - 1)
            const prevY = padding.top + chartHeight - ((shopSeries.data[index - 1].value - minValue) / range) * chartHeight
            const cpX = (prevX + x) / 2
            ctx.bezierCurveTo(cpX, prevY, cpX, y, x, y)
          }
        })
        ctx.stroke()
        ctx.shadowBlur = 0

        shopSeries.data.forEach((item, index) => {
          const x = padding.left + (chartWidth / (dates.length - 1 || 1)) * index
          const y = padding.top + chartHeight - ((item.value - minValue) / range) * chartHeight

          ctx.beginPath()
          ctx.arc(x, y, 5, 0, Math.PI * 2)
          ctx.fillStyle = '#fff'
          ctx.fill()
          ctx.strokeStyle = shopSeries.color
          ctx.lineWidth = 2.5
          ctx.stroke()

          ctx.beginPath()
          ctx.arc(x, y, 2.5, 0, Math.PI * 2)
          ctx.fillStyle = shopSeries.color
          ctx.fill()
        })
      })
    },
    getOrderStatusType(status) {
      return orderStatusTypeMap[status] || 'info'
    },
    getOrderStatusText(status) {
      return orderStatusMap[status] || status
    }
  }
}
</script>
<style scoped>
.dashboard {
  animation: fadeIn 0.3s ease;
}
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}
.stat-card {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  display: flex;
  align-items: center;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.3s;
}
.stat-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.stat-icon {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  flex-shrink: 0;
}
.stat-icon i {
  font-size: 28px;
}
.stat-body {
  flex: 1;
}
.stat-label {
  font-size: 14px;
  color: #8c8c8c;
  margin-bottom: 6px;
}
.stat-value {
  font-size: 28px;
  font-weight: 700;
  color: #1f1f1f;
}
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.legend-control {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  max-width: 300px;
}
.legend-control .el-checkbox {
  margin: 0;
}
.card-header span {
  font-size: 16px;
  font-weight: 600;
  color: #1f1f1f;
}
.chart-container {
  padding: 10px;
}
</style>
